/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListBatchesRequest = {
  after?: string | undefined;
  limit?: number | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListBatchesRequest$inboundSchema: z.ZodType<
  ListBatchesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  after: z.string().optional(),
  limit: z.number().int().default(20),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListBatchesRequest$Outbound = {
  after?: string | undefined;
  limit: number;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListBatchesRequest$outboundSchema: z.ZodType<
  ListBatchesRequest$Outbound,
  z.ZodTypeDef,
  ListBatchesRequest
> = z.object({
  after: z.string().optional(),
  limit: z.number().int().default(20),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listBatchesRequestToJSON(
  listBatchesRequest: ListBatchesRequest,
): string {
  return JSON.stringify(
    ListBatchesRequest$outboundSchema.parse(listBatchesRequest),
  );
}
export function listBatchesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListBatchesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListBatchesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListBatchesRequest' from JSON`,
  );
}
